import React from "react";
import { InvestigationButtonLabels } from "../../../Utils/helper";
import CommonButton from "../../../CommonComponents/CommonButton";

function InvestigationActionButtons({
  onClick = () => {},
  hideButton = false,
}) {
  return hideButton ? (
    ""
  ) : (
    <>
      <CommonButton
        label={InvestigationButtonLabels[0]}
        isColor
        backgroundColor="#FF9763"
        removeBorder
        textColor="white"
        isHover
        hoverColor="#FF9763"
        sx={{
          fontSize: "1.1rem",
          width: "fit-content",
          padding: "0.3rem 1.5rem",
        }}
        onClick={onClick}
      />
      <CommonButton
        label={InvestigationButtonLabels[1]}
        isColor
        backgroundColor="#58E39E"
        removeBorder
        textColor="white"
        isHover
        hoverColor="#58E39E"
        sx={{
          fontSize: "1.1rem",
          width: "fit-content",
          padding: "0.3rem 0.8rem",
        }}
        onClick={onClick}
      />
      <CommonButton
        label={InvestigationButtonLabels[2]}
        isColor
        backgroundColor="#F87A83"
        removeBorder
        textColor="white"
        isHover
        hoverColor="#F87A83"
        sx={{
          fontSize: "1.1rem",
          width: "fit-content",
          padding: "0.3rem 0.8rem",
        }}
        onClick={onClick}
      />
    </>
  );
}

export default InvestigationActionButtons;
